var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGood2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77333 15.8762C7.86835 15.8762 8.75604 14.9885 8.75604 13.8935C8.75604 12.7984 7.86835 11.9107 6.77333 11.9107C5.67831 11.9107 4.79063 12.7984 4.79063 13.8935C4.79063 14.9885 5.67831 15.8762 6.77333 15.8762Z",
    fill: "#CED5EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0692 15.8762C28.1642 15.8762 29.0519 14.9885 29.0519 13.8935C29.0519 12.7984 28.1642 11.9107 27.0692 11.9107C25.9742 11.9107 25.0865 12.7984 25.0865 13.8935C25.0865 14.9885 25.9742 15.8762 27.0692 15.8762Z",
    fill: "#CED5EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8396 20.1904C11.8396 19.442 11.2328 18.8352 10.4844 18.8352C9.73592 18.8352 9.12917 19.442 9.12917 20.1904C9.12917 23.9346 12.8356 26.4589 16.7015 26.4589C20.5678 26.4589 24.2738 23.9316 24.2738 20.1904C24.2738 19.442 23.667 18.8352 22.9186 18.8352C22.1701 18.8352 21.5634 19.442 21.5634 20.1904C21.5634 21.8748 19.7003 23.7485 16.7015 23.7485C13.7021 23.7485 11.8396 21.8769 11.8396 20.1904Z",
    fill: "#CED5EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7031 16.4248C32.7031 25.2614 25.5397 32.4248 16.7031 32.4248C7.86657 32.4248 0.703125 25.2614 0.703125 16.4248C0.703125 7.58825 7.86657 0.424805 16.7031 0.424805C25.5397 0.424805 32.7031 7.58825 32.7031 16.4248ZM16.7031 30.8248C24.656 30.8248 31.1031 24.3777 31.1031 16.4248C31.1031 8.4719 24.656 2.0248 16.7031 2.0248C8.75022 2.0248 2.30312 8.4719 2.30312 16.4248C2.30312 24.3777 8.75022 30.8248 16.7031 30.8248Z",
    fill: "#CED5EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood2);
export default __webpack_public_path__ + "static/media/good-2.b846ebb8836caf8bb2dec14a39385ca2.svg";
export { ForwardRef as ReactComponent };